import { scrollToId } from "@/lib/scroll";
import Reveal from "@/components/Reveal";
import Footer from "@/components/Footer";

const SALURAN = [
  {
    testid: "aduan-span-lapor",
    href: "https://www.lapor.go.id/",
    label: "SPAN LAPOR",
  },
  {
    testid: "aduan-inspektorat",
    href: "https://wbs.kemdiktisaintek.go.id/",
    label: "INSPEKTORAT JENDERAL",
  },
  {
    testid: "aduan-lapor-lldikti",
    href: "https://docs.google.com/forms/d/e/1FAIpQLScKYN1tUCvBOPcPOZByxlXpdR81XFM0ZKwq2QMHhf3Sf-t8VA/viewform",
    label: "LAPOR LLDIKTI VII",
  },
  {
    testid: "aduan-whatsapp",
    href: "http://wa.me/62085282784047",
    label: "WhatsAPP ke 0852-8278-4047",
  },
];

export default function SaluranPengaduan() {
  return (
    <div className="min-h-screen bg-white text-[#0B2440] antialiased">
      <main className="px-6 pb-20 pt-28 md:px-12 md:pt-32">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-[#1479BF]">
            <span
              aria-hidden="true"
              className="h-1.5 w-1.5 rounded-full bg-[#E8A33D]"
            />
            Layanan Informasi — Saluran Pengaduan
          </p>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-semibold leading-[1.05] text-[#0B2440] md:text-6xl">
            WHISTLEBLOWING SYSTEM LLDIKTI WILAYAH VII
          </h1>
          <div className="mt-6 h-1.5 w-20 rounded-full bg-[#E8A33D]" />
        </Reveal>

        <Reveal delay={0.1}>
          <p
            data-testid="aduan-text"
            className="mt-12 max-w-3xl text-[15px] leading-relaxed text-slate-600 md:text-base"
          >
            Apabila masyarakat mendapati pelayanan LLDIKTI Wilayah VII yang
            tidak memuaskan atau di luar prosedur yang berlaku, silahkan
            menyampaikan pengaduan melalui email yang tertera{" "}
            <button
              data-testid="aduan-kontak-link"
              onClick={() => scrollToId("#kontak")}
              className="font-semibold text-[#1479BF] hover:underline"
            >
              pada Kontak dibawah
            </button>{" "}
            atau pada salah satu saluran berikut ini:
          </p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-12 grid max-w-3xl gap-4 sm:grid-cols-2">
            {SALURAN.map((s) => (
              <a
                key={s.testid}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={s.testid}
                className="inline-flex items-center justify-center rounded-full bg-[#1479BF] px-7 py-3.5 text-center text-xs font-bold tracking-[0.08em] text-white transition-colors duration-300 hover:bg-[#0B2440]"
              >
                {s.label}
              </a>
            ))}
          </div>
        </Reveal>
      </main>
      <Footer compact />
    </div>
  );
}
